const n = "_disabled_pnjqc_13", o = "_heroContainer_pnjqc_13", t = "_wrapping_pnjqc_38", _ = "_textContainer_pnjqc_49", r = "_notWrapping_pnjqc_54", a = "_infoIcon_pnjqc_86", e = {
  "root-base": "_root-base_pnjqc_1",
  disabled: n,
  heroContainer: o,
  "root-vertical": "_root-vertical_pnjqc_22",
  "root-horizontal": "_root-horizontal_pnjqc_30",
  wrapping: t,
  textContainer: _,
  notWrapping: r,
  infoIcon: a
};
export {
  e as default,
  n as disabled,
  o as heroContainer,
  a as infoIcon,
  r as notWrapping,
  _ as textContainer,
  t as wrapping
};
//# sourceMappingURL=index.es685.js.map
